import {
  LightBulbIcon,
  FileCodeIcon,
  TasklistIcon,
  BookIcon,
  GitPullRequestIcon,
  BeakerIcon,
} from '@primer/octicons-react'
import type {IcebreakerOption} from './icebreaker'

export const agentIcebreakers: IcebreakerOption[] = [
  {
    title: 'Explain repository',
    subheader: 'Understand the codebase and where to start',
    icon: <LightBulbIcon size={16} className="fgColor-muted" />,
    prompt:
      'Explore this repository and explain what it does, how it is organized, and its main entry points. Suggest a short reading path through the most important files.',
  },
  {
    title: 'Create a plan',
    subheader: 'Plan before making changes to the codebase',
    icon: <TasklistIcon size={16} className="fgColor-muted" />,
    prompt:
      "What would you like to change? Share an issue link or describe your goal, and I'll explore the codebase and create an implementation plan before making changes.",
    createPullRequest: false,
  },
  {
    title: 'Fix a bug',
    subheader: 'Get help diagnosing and fixing an error',
    icon: <FileCodeIcon size={16} className="fgColor-muted" />,
    prompt: "Paste an issue link or a stack trace, and I'll help track down the cause and work on a fix.",
  },
  {
    title: 'Add tests',
    subheader: 'Cover important behaviors and edge cases',
    icon: <BeakerIcon size={16} className="fgColor-muted" />,
    prompt:
      "Inspect the existing tests and identify an important behavior or edge case that lacks coverage. Add focused tests using the repository's existing test framework and run the relevant tests if available.",
  },
  {
    title: 'Improve docs',
    subheader: 'Make the project easier to understand and use',
    icon: <BookIcon size={16} className="fgColor-muted" />,
    prompt:
      'Compare the README and developer documentation with the current code and scripts. Fix a meaningful gap or outdated instruction, grounding every change in the repository.',
  },
  {
    title: 'Build a feature',
    subheader: 'Turn an idea or issue into working code',
    icon: <FileCodeIcon size={16} className="fgColor-muted" />,
    prompt:
      "Share an issue link or describe what you'd like to build. I'll explore the relevant code and help implement it.",
  },
  {
    title: 'Review a pull request',
    subheader: 'Get a second look before you merge',
    icon: <GitPullRequestIcon size={16} className="fgColor-muted" />,
    prompt:
      "Share a pull request link. I'll examine the changes for correctness, missing tests, and potential regressions.",
  },
]

export function getIcebreakers(): IcebreakerOption[] {
  const remaining = [...agentIcebreakers]
  const selected: IcebreakerOption[] = []

  while (selected.length < 3) {
    const index = Math.floor(Math.random() * remaining.length)
    selected.push(...remaining.splice(index, 1))
  }

  return selected
}
